export default "__VITE_ASSET__e43d4345__"